module.exports = __webpack_public_path__ + "static/meta-image-393ae2057ea2788a07a3d23318fc4589.png";